import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

interface AnalyticsResponse {
  data: any
  analytics: any
  registration: any
  personalization_module_enabled: any
}

export const AnalyticsApi = createApi({
  reducerPath: 'analyticsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_BASE_URL,
  }),
  endpoints: (build) => ({
    getAnalytics: build.query<AnalyticsResponse, { instId; locId; tourId }>({
      query: ({ instId, locId, tourId }) =>
        `getAnalyticsAndRegistrationAttributes/${instId}/${locId}?tourid=${tourId}`,
    }),
  }),
})

export const { useGetAnalyticsQuery } = AnalyticsApi
